import { params } from '@didi/driver-biz-sdk'
import { env } from '@didi/utils'

export const ACTIVITY_STATUS_MAP = {
  wait: 0,
  doing: 1,
  end: 2
}

export const BTN_STATUS_MAP = {
  hidden: 0,
  show: 1,
  disabled: 2
}

export const isInApp = env.isDriver || env.rainbow || params.urlParams.ticket

export const NAME_MAP = {
  20001: '中国人民财产保险股份有限公司',
  20002: '中国太平洋财产保险股份有限公司',
  20003: '众诚汽车保险股份有限公司',
  20004: '大家财产保险有限责任公司'
}
export const SHORT_NAME_MAP = {
  20001: '人保',
  20002: '太保',
  20003: '众诚',
  20004: '大家财险'
}

export const DAY_TIME = 24 * 60 * 60

export const PLATFORM = (() => {
  if (env.isDriver) return 1 // 车主端
  if (env.rainbow) return 2 // 司机部落
  if (env.isWechat) return 3 // 微信
  else return 0
})()

export const INSURANCE_ID = 1100

export const INSURANCE_STATUS = {
  unJoin: 0,
  waitEffect: 1,
  effect: 2,
  expired: 3,
  paused: 4,
  canRenewal: 5, // 目前没用
  exited: 6
} as const

export const INSURANCE_TYPE = {
  1101: {
    text: '意外伤害保障',
    color: '#3CB496',
    bgc: '#E3FAF6'
  },
  1102: {
    text: '住院津贴保障',
    color: '#4284FF',
    bgc: '#E3ECFF'
  },
  1103: {
    text: '百万医疗保障',
    color: '#FF7F41',
    bgc: '#FFEDE4'
  }
} as const

export const PAGE_URL = process.env.API_ENV === 'production'
  ? 'https://page.udache.com/driver-biz/driver-medical-insurance'
  : 'http://h5test.intra.xiaojukeji.com/driver-biz/driver-medical-insurance'

/**
 * 1: 补贴-个人信息授权书；
 * 2: 补贴-委托付款授权确认书；
 * 3: 自费-个人信息保护法
 * */
export const PROTOCAOL_LIST = {
  1: 'https://page.udache.com/driver-activity-biz/baichuan-policy-agreement/index.html?mode=2&bc_scene=SJZSYLYWBX&lang=zh-CN&bc_appid=20000&appversion=SJZSYLYWBX',
  2: 'https://page.udache.com/driver-activity-biz/baichuan-policy-agreement/index.html?mode=2&bc_scene=ZSYLBXWTFK&lang=zh-CN&bc_appid=20000&appversion=ZSYLBXWTFK',
  3: 'https://page.udache.com/driver-activity-biz/baichuan-policy-agreement/index.html?mode=2&bc_scene=BXyiliaozifei&lang=zh-CN&bc_appid=20000&appversion=BXyiliaozifei#/xpub?s=op-json-95wqh3P6d&cid=113430&cnt_id=22111515867'
}

export const QA_URL = 'https://dpubstatic.udache.com/static/dpubimg/656e2a01474f9a29f0c155d791379b38/index.html'
export const RULE_URL = 'https://dpubstatic.udache.com/static/dpubimg/f621ab448e6902bf29083230faecf380/index.html'

export const PAGE_TYPE_MAP = {
  normal: 0,
  driverDay: 1 // 司机节
} as const

export const ALL_PAGE = process.env.API_ENV === 'development'
  ? 'http://static-daily.am.xiaojukeji.com/driver-fe/taxi-driver-thanos/pages/protection-plan/index.html?source=1'
  : 'https://page.udache.com/driver-fe/taxi-driver-thanos/pages/protection-plan/index.html?source=1'

export enum DRIVER_GRADE {
  kuaiche = '7', // 快车
  d1 = '76', // D1定制车
  tehui = '77', // 特惠快车
  zhuanche = '5' // 专车
}

export enum KUAICHE_LEVEl_MAP {
  one = 1, // L1
  two = 2, // L2
  three = 3, // L3
  four = 4, // L4
  five = 5, // L5
  six = 6 // L6
}
export const KUAICHE_TEXT_MAP = {
  [KUAICHE_LEVEl_MAP.one]: 'L1 城市王牌',
  [KUAICHE_LEVEl_MAP.two]: 'L2 城市英雄',
  [KUAICHE_LEVEl_MAP.three]: 'L3 城市英雄',
  [KUAICHE_LEVEl_MAP.four]: 'L4 城市传奇',
  [KUAICHE_LEVEl_MAP.five]: 'L5 城市传奇',
  [KUAICHE_LEVEl_MAP.six]: 'L6 城市传奇'
}

export enum ZHUANCHE_LEVEL_MAP {
  authentication = 1, // 认证司机
  senior = 2, // 资深司机
  outstanding = 7, // 杰出司机
  specialStar = 8 // 明星司机
}

export const ZHUANCHE_TEXT_MAP = {
  [ZHUANCHE_LEVEL_MAP.authentication]: '认证司机',
  [ZHUANCHE_LEVEL_MAP.senior]: '资深司机',
  [ZHUANCHE_LEVEL_MAP.outstanding]: '杰出司机',
  [ZHUANCHE_LEVEL_MAP.specialStar]: '明星司机'
}

export const KUAICHE_LEVEL_COLOR = {
  [KUAICHE_LEVEl_MAP.one]: '#8F98F8',
  [KUAICHE_LEVEl_MAP.two]: '#60E7FC',
  [KUAICHE_LEVEl_MAP.three]: '#B3F899',
  [KUAICHE_LEVEl_MAP.four]: '#FDD080',
  [KUAICHE_LEVEl_MAP.five]: '#FCA057',
  [KUAICHE_LEVEl_MAP.six]: '#B1BEFF',
  disabled: '#DBDBDB'
}

export const ZHUANCHE_LEVEL_COLOR = {
  [ZHUANCHE_LEVEL_MAP.authentication]: '#FF6400',
  [ZHUANCHE_LEVEL_MAP.senior]: '#FF6400',
  [ZHUANCHE_LEVEL_MAP.outstanding]: '#FF6400',
  [ZHUANCHE_LEVEL_MAP.specialStar]: '#FF6400',
  disabled: '#DBDBDB'
}

export const KUAICHE_LEVEL_LIGHT_ICON = {
  [KUAICHE_LEVEl_MAP.one]: 'https://dpubstatic.udache.com/static/dpubimg/Y5YnYM14OrD8HjS3WZAKo.png',
  [KUAICHE_LEVEl_MAP.two]: 'https://dpubstatic.udache.com/static/dpubimg/zo4eAdQY9rp_opziO-wb9.png',
  [KUAICHE_LEVEl_MAP.three]: 'https://dpubstatic.udache.com/static/dpubimg/cuhQXvnJ9X0lp_g2ykUaA.png',
  [KUAICHE_LEVEl_MAP.four]: 'https://dpubstatic.udache.com/static/dpubimg/BTJv08gD5fPjWpdcz23QB.png',
  [KUAICHE_LEVEl_MAP.five]: 'https://dpubstatic.udache.com/static/dpubimg/P53fLKXeQ1y6VkTh-qSwJ.png',
  [KUAICHE_LEVEl_MAP.six]: 'https://dpubstatic.udache.com/static/dpubimg/pBWROOy0Tgeu0GerFIpHV.png'
}

export const KUAICHE_LEVEL_GREY_ICON = {
  [KUAICHE_LEVEl_MAP.one]: 'https://dpubstatic.udache.com/static/dpubimg/cp0KF4MY4dNcgU5FPfxch.png',
  [KUAICHE_LEVEl_MAP.two]: 'https://dpubstatic.udache.com/static/dpubimg/0fxQ_Xrk8IV2XJFoKPIta.png',
  [KUAICHE_LEVEl_MAP.three]: 'https://dpubstatic.udache.com/static/dpubimg/KYneK3-2QCKRwMWTeOh4x.png',
  [KUAICHE_LEVEl_MAP.four]: 'https://dpubstatic.udache.com/static/dpubimg/R0Rmr6ZBAjiuahiBNLocm.png',
  [KUAICHE_LEVEl_MAP.five]: 'https://dpubstatic.udache.com/static/dpubimg/Se3kojb8Jrsjl2mymwD1j.png',
  [KUAICHE_LEVEl_MAP.six]: 'https://dpubstatic.udache.com/static/dpubimg/TA6zZ7EyjYYanuGwrEcSb.png'
}

export const ZHUANCHE_LEVEL_LIGHT_ICON = {
  [ZHUANCHE_LEVEL_MAP.authentication]: 'https://dpubstatic.udache.com/static/dpubimg/Ex7DJawoyHKvYlDbCRuvh.png',
  [ZHUANCHE_LEVEL_MAP.senior]: 'https://dpubstatic.udache.com/static/dpubimg/49LvKjg36coBi0hV_Bpv9.png',
  [ZHUANCHE_LEVEL_MAP.outstanding]: 'https://dpubstatic.udache.com/static/dpubimg/GG2iyjs5tA3-BlCkvFUcD.png',
  [ZHUANCHE_LEVEL_MAP.specialStar]: 'https://dpubstatic.udache.com/static/dpubimg/wrxaJaY0auugSnivFRW3c.png'
}

export const ZHUANCHE_LEVEL_GREY_ICON = {
  [ZHUANCHE_LEVEL_MAP.authentication]: 'https://dpubstatic.udache.com/static/dpubimg/gte44i06A5yevtQfpZtCY.png',
  [ZHUANCHE_LEVEL_MAP.senior]: 'https://dpubstatic.udache.com/static/dpubimg/fjG0NS-Q8TlTR2VOrNU3i.png',
  [ZHUANCHE_LEVEL_MAP.outstanding]: 'https://dpubstatic.udache.com/static/dpubimg/EBdTk4Y9fryxzTRQ2kjT2.png',
  [ZHUANCHE_LEVEL_MAP.specialStar]: 'https://dpubstatic.udache.com/static/dpubimg/zbKmFcbU8C6zF49iNSHnU.png'
}
